module.exports = __webpack_public_path__ + "img/sample01.dbdd81ae.gif";